import React from 'react';
import { severityFromPct, TPL_SEVERITY_STYLE } from '../../services/tplSeverityStyles';

export interface DataflowPillarItem {
  key: string;
  label: string;
  value: number | null;
  display?: string;
}

interface DataflowCompactPillarsProps {
  pillars: DataflowPillarItem[];
  className?: string;
}

/** Painel horizontal compacto — IEL · Maturidade · pilares em uma linha. */
export const DataflowCompactPillars: React.FC<DataflowCompactPillarsProps> = ({
  pillars,
  className = '',
}) => (
  <div
    className={`flex flex-wrap items-stretch gap-1 rounded-lg border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950/30 ${className}`}
  >
    {pillars.map((p) => {
      const display = p.display ?? (p.value != null ? `${p.value}%` : 'N/A');
      const severity =
        p.value != null ? severityFromPct(p.value) : ('informativo' as const);
      const style = TPL_SEVERITY_STYLE[severity];
      return (
        <div
          key={p.key}
          className={`min-w-[100px] flex-1 border-r border-slate-100 px-2 py-1.5 last:border-r-0 dark:border-slate-800`}
        >
          <p className="text-[8px] font-bold uppercase tracking-wide text-slate-400">{p.label}</p>
          <p className={`text-[14px] font-black tabular-nums leading-tight ${style.accent}`}>
            {display}
          </p>
        </div>
      );
    })}
  </div>
);

export function buildExecutiveCompactPillars(input: {
  iel: number;
  maturidade: number;
  disciplina: number;
  conformidade: number;
  escalonamento: number;
}): DataflowPillarItem[] {
  return [
    { key: 'iel', label: 'IEL', value: input.iel, display: `${input.iel}` },
    { key: 'maturidade', label: 'Maturidade', value: input.maturidade, display: `${input.maturidade}` },
    { key: 'disciplina', label: 'Disciplina', value: input.disciplina },
    { key: 'conformidade', label: 'Conformidade', value: input.conformidade },
    { key: 'escalonamento', label: 'Escalonamento', value: input.escalonamento },
  ];
}

export function pillarsFromMaturity(pillars: {
  disciplina: number;
  conformidade: number;
  escalonamento: number;
  sustentacao: number;
  resultados: number | null;
}): DataflowPillarItem[] {
  return [
    { key: 'disciplina', label: 'Disciplina', value: pillars.disciplina },
    { key: 'conformidade', label: 'Conformidade', value: pillars.conformidade },
    { key: 'escalonamento', label: 'Escalonamento', value: pillars.escalonamento },
    { key: 'sustentacao', label: 'Sustentação', value: pillars.sustentacao },
    {
      key: 'resultados',
      label: 'Resultados',
      value: pillars.resultados,
      display: pillars.resultados != null ? `${pillars.resultados}%` : 'N/A',
    },
  ];
}

export default DataflowCompactPillars;
